function initHandlePDPSectionRender(){
    function chunkArray(myArray, chunkSize) {
       const results = [];
       const totalChunks = Math.ceil(myArray.length / chunkSize);
    
       for (let i = 0; i < totalChunks; i++) {
         const startIndex = i * chunkSize;
         const endIndex = startIndex + chunkSize;
         results.push(myArray.slice(startIndex, endIndex));
       };
    
       return results;
     };
     function handleSectionRender(){
         document.querySelectorAll('[data-handle-section-render]').forEach((button) => {
             const section_id = button.dataset.sectionId;
             const product_url = button.dataset.productItemUrl;
             button.onclick = function() {
             const id = 'shopify-section-' + section_id.split('__')[0];
             let sections = [...document.querySelectorAll(`[id*=${id}]`)];
             let split_sections = false;
             if (sections.length > 5) {
                 split_sections = chunkArray(sections, 5);
             }
             if (split_sections) {
                 split_sections.forEach(async (array) => {
                 let sections_string = array
                     .map((section) => {
                     return section.id.replace('shopify-section-', '');
                     })
                     .join(',');
                 const url = product_url + '?sections=' + sections_string;
                 fetch(url)
                     .then((response) => response.json())
                     .then((data) => {
                     sections.forEach((section) => {
                         const id = section.id.replace('shopify-section-', '');
                         if (data[id]) {
                         section.innerHTML = data[id];
                         }
                     });
                     document.dispatchEvent(new CustomEvent('section:reload'));
                     history.pushState({}, '', `${window.location.origin}${product_url}`);
                     window.handleSectionRender();
                     })
                 })
             }
         }})
     }
    handleSectionRender()
    window.handleSectionRender = handleSectionRender;
   };

    export { initHandlePDPSectionRender };